import React from 'react';  
import queryString from 'query-string';
import LineworxClient from '../lineworxClient';
import JobView from './JobView';
import TicketView from '../Ticket/TicketView';
import EditJobView from './EditJobView';
import TaskView from '../Task/TaskView';
import moment from 'moment';

export default class Job extends React.Component {    

    state = {//Job View props
        job:{},
        filteredPole: 'All',
        filteredLine:'All',
        filteredStatus:'All',
        filteredTickets:[],
        uniquePoles:[],
        uniqueLines:[],
        sort_dir:"asc",
      sort_col: "pole_name",

        //TicketView props
        //Active ticket is used when showing the ticket popup
        activeTicketCopy:undefined,
        activeTicketDirty:false, //If changes have been made to the active ticket
        activePoleCopy:{},
        activePoleDirty:false,
        atPoleText:null, //Represents what the user has manually typed into the field, but we don't have a pole to go with it to assign to the ticket
        atLineText:null, //Represents what the user has manually typed into the field, but we don't have a pole to go with it to assign to the ticket
        atSubStationText:null, //Represents what the user has manually typed into the field, but we don't have a pole to go with it to assign to the ticket
        atCurcuitText:null, //Represents what the user has manually typed into the field, but we don't have a pole to go with it to assign to the ticket
        atPoleIdText:null, //Represents what the user has manually typed into the field, but we don't have a pole to go with it to assign to the ticket
        atLineIdText:null, //Represents what the user has manually typed into the field, but we don't have a pole to go with it to assign to the ticket
        statuses:['All', 'Pending', 'Complete'],
        mergeRequired:false,
        overrideMerge: false,
        ticketIdToMerge: -1,
        selectedTab:'home',
        showStationSelections:false,
        showSavePoleChanges:false,
        saving:false,
        addPoleError:false,
        needsMerge:false,
        sortPoles:'pole_name',
        sortPoleAsc:true,
        dueDate: null,

        //ticket Info
        ehasp:null,
        specHintData:null,
        specText:null,
        activeWorkingNote:null,
        loadingPermitDnD:[false],
        loadingDigSafeDnD:false,
        loadingNRADnD:false,
        loadingPacket:false,

        //ticket tasks
        // serviceTasks:null,
        // showCreateTask: false,



        //Edit Job Props
        jobForEditView:undefined,
        showDueDateCalendar:false,
        jobDueDateFormatted:'',
        showEditJob:false,
        utilsForDropdown:[],
        jobCanSave:true,
        isJobDirty:false,
        jobPacketFile:undefined,

        // task stuff
        newTask: null,
        taskName: null,
        category_id: null,
        taskCategories: {}
    };

    constructor(props) {
        super(props);

        this.resetChildrenState=this.resetChildrenState.bind(this);

        //Job methods
        this.handleBack = this.handleBack.bind(this);
        this.hideDueDateCalendar = this.hideDueDateCalendar.bind(this);
        this.closeEditJob=this.closeEditJob.bind(this);
        this.showEditJob=this.showEditJob.bind(this);
        this.deleteJob = this.deleteJob.bind(this);
        this.handlePoleFilterSelect = this.handlePoleFilterSelect.bind(this);
        this.toggleShowDueDateCalendar = this.toggleShowDueDateCalendar.bind(this);
        this.handleLineFilterSelect = this.handleLineFilterSelect.bind(this);
        this.handleStatusFilterSelect = this.handleStatusFilterSelect.bind(this);
        this.toggleCreateTicket = this.toggleCreateTicket.bind(this);
        this.viewTicket=this.viewTicket.bind(this);
        this.createEmptyTicket=this.createEmptyTicket.bind(this);
        this.checkJobDirty=this.checkJobDirty.bind(this);
        this.sortBy=this.sortBy.bind(this);
        this.spreadsheetUpload = this.spreadsheetUpload.bind(this);
        this.triggerFileSelectDialog = this.triggerFileSelectDialog.bind(this);


        //Ticket methods
        this.changePoleText = this.changePoleText.bind(this);
        this.changeSubStationText = this.changeSubStationText.bind(this);
        this.changeCurcuitText = this.changeCurcuitText.bind(this);
        this.changeLineText = this.changeLineText.bind(this);
        this.closeWindow = this.closeWindow.bind(this);
        this.savePole = this.savePole.bind(this);
        this.addPole=this.addPole.bind(this);
        this.changePoleAddress=this.changePoleAddress.bind(this);
        this.arcRatingChange = this.arcRatingChange.bind(this);
        this.secondaryVoltageChange = this.secondaryVoltageChange.bind(this);
        this.primaryVoltageChange = this.primaryVoltageChange.bind(this);
        this.latitudeChange = this.latitudeChange.bind(this);
        this.longitudeChange = this.longitudeChange.bind(this);
        this.handleSelectAccessType = this.handleSelectAccessType.bind(this);
        this.getSpecificPole = this.getSpecificPole.bind(this);
        this.handleSelectTicketTab = this.handleSelectTicketTab.bind(this);
        this.changePoleOnTicket = this.changePoleOnTicket.bind(this);
        this.wouldPoleNeedMerge=this.wouldPoleNeedMerge.bind(this);
        this.mergeTickets=this.mergeTickets.bind(this);
        this.saveTicket=this.saveTicket.bind(this);
        this.checkTicketDirty=this.checkTicketDirty.bind(this);
        this.setPoleSort=this.setPoleSort.bind(this);
        this.setSortPoleAsc=this.setSortPoleAsc.bind(this);
        this.resetPoleId=this.resetPoleId.bind(this);
        this.tasksChanged=this.tasksChanged.bind(this);

        //TicketTasks and TicketInfo methods

          this.setSpecText = this.setSpecText.bind(this);
            this.updateTicketDescription = this.updateTicketDescription.bind(this);
            // this.expandTaskSection = this.expandTaskSection.bind(this);
            // this.taskChecked = this.taskChecked.bind(this);
            this.changeRadio=this.changeRadio.bind(this);
            this.handleAmbMeetup = this.handleAmbMeetup.bind(this);
            this.handleEhasp = this.handleEhasp.bind(this);
            this.handleDigDrop = this.handleDigDrop.bind(this);
            this.handleNRADrop = this.handleNRADrop.bind(this);
            this.handlePermitDrop=this.handlePermitDrop.bind(this);
            this.changePermitType=this.changePermitType.bind(this);
            this.addPermit = this.addPermit.bind(this);
            this.handleDeleteWoChip = this.handleDeleteWoChip.bind(this)
            this.handleAddWoChip = this.handleAddWoChip.bind(this)
            this.addNote=this.addNote.bind(this);
            this.toggleAddNote=this.toggleAddNote.bind(this);
            this.updateActiveNote=this.updateActiveNote.bind(this);
            this.handleWorkingForemanChange=this.handleWorkingForemanChange.bind(this);
            this.digsafe = React.createRef();
            this.permit_0 = React.createRef();
            this.nra = React.createRef();
            this.xlsUpload = React.createRef();
            
            this.handleDigSafeFileUpload = this.handleDigSafeFileUpload.bind(this)
            this.handleNRAFileUpload = this.handleNRAFileUpload.bind(this)
            this.handlePermitFileUpload = this.handlePermitFileUpload.bind(this)
            this.handleDigFileSelectClick=this.handleDigFileSelectClick.bind(this);
            this.handleNraFileSelectClick=this.handleNraFileSelectClick.bind(this);
            this.handlePermitFileSelectClick=this.handlePermitFileSelectClick.bind(this);
            this.removeFile = this.removeFile.bind(this);
            this.removeWorkPacket = this.removeWorkPacket.bind(this);
            

    
    
        //Edit Job methods
        //this.toggleEditJob = this.toggleEditJob.bind(this);
        this.handleSelectJobType = this.handleSelectJobType.bind(this);
        this.onDueDateChanged = this.onDueDateChanged.bind(this);
        this.handleSelectUtility = this.handleSelectUtility.bind(this);
        this.handlePacketDrop = this.handlePacketDrop.bind(this);
        this.saveJob = this.saveJob.bind(this);
        this.handleHospName = this.handleHospName.bind(this);
        this.handleWorkContactPhone = this.handleWorkContactPhone.bind(this);
        this.handleHospAddress = this.handleHospAddress.bind(this);
        this.handleSelectForeman = this.handleSelectForeman.bind(this);
        this.hideCalendarFromDocClickIfNeeded=this.hideCalendarFromDocClickIfNeeded.bind(this);
        this.handleJobPacketUpload = this.handleJobPacketUpload.bind(this);
        this.handlePackageFileSelectClick=this.handlePackageFileSelectClick.bind(this);
        this.job_packet = React.createRef();

        // task functions
        // this.getCategoriesForTask = this.getCategoriesForTask.bind(this);
        // this.handleTaskCategoryChange = this.handleTaskCategoryChange.bind(this);
        // this.saveTask = this.saveTask.bind(this);
        // this.handleTaskName = this.handleTaskName.bind(this);
        // this.toggleCreateTask = this.toggleCreateTask.bind(this);
    }

    resetChildrenState() {
        this.setState({
            
            //TicketView props
            //Active ticket is used when showing the ticket popup
            activeTicketCopy:undefined,
            activeTicketDirty:false, //If changes have been made to the active ticket
            activePoleCopy:{},
            activePoleDirty:false,
            atPoleText:null, //Represents what the user has manually typed into the field, but we don't have a pole to go with it to assign to the ticket
            atLineText:null, //Represents what the user has manually typed into the field, but we don't have a pole to go with it to assign to the ticket
            atSubStationText:null, //Represents what the user has manually typed into the field, but we don't have a pole to go with it to assign to the ticket
            atCurcuitText:null, //Represents what the user has manually typed into the field, but we don't have a pole to go with it to assign to the ticket
            atPoleIdText:null, //Represents what the user has manually typed into the field, but we don't have a pole to go with it to assign to the ticket
            atLineIdText:null, //Represents what the user has manually typed into the field, but we don't have a pole to go with it to assign to the ticket
            statuses:['All', 'Pending', 'Complete'],
            mergeRequired:false,
            overrideMerge: false,
            ticketIdToMerge: -1,
            selectedTab:'home',
            showStationSelections:false,
            showSavePoleChanges:false,
            saving:false,
            addPoleError:false,
            needsMerge:false,
            sortPoles:'',
            sortPoleAsc:true,
    
    
            //ticket Info
            ehasp:null,
            specHintData:null,
            specText:null,
            activeWorkingNote:null,
            loadingPermitDnD:[false],
            loadingDigSafeDnD:false,
            loadingNRADnD:false,
            loadingPacket:false,
    
            //ticket tasks
            // currentTaskSection:null,
            // expandedTaskSections:[],
    
    
            //Edit Job Props
            jobForEditView:undefined,
            showDueDateCalendar:false,
            jobDueDateFormatted:'',
            showEditJob:false,
            jobPacketFile:undefined,
            isJobDirty:false
        });
    }

    setPoleSort(sort) {
        this.setState({
            sortPoles:sort
        })
    }

    setSortPoleAsc(asc) {
        this.setState({
            sortPoleAsc:asc
        });
    }


    componentDidMount() {
        let params = queryString.parse(this.props.location.search)
        let jid = params["id"];
        if(jid) {
            this.getJob(jid);
        }
        this.getUtilities();
        this.getForemen();
        this.getWorkingForemen();
        this.getAccessibilityTypes();
        // this.getServiceTasks();
        this.getSpecData();
        // this.getCategoriesForTask();
    }

    async getSpecData() {
      const res = await LineworxClient.getSpecsByPartial();
      var hintArray = []
      if(res.body) {
          res.body.map(a => hintArray.push(a.spec_number));
          this.setState({
              specHintData:hintArray
          })
      }
      
  }

  toggleCreateTask(event) {

    if(!this.state.newTask) {
      this.setState({
        newTask: true
      });
    } else {
      this.setState({
        newTask: undefined
      })
    }
  }

    handleTaskName(e) {
        this.setState({
            taskName: e.target.value
        })
    }

    // async saveTask() {
    //     let task = {category_id: this.state.category_id, task_name: this.state.taskName}
    //     let response = await LineworxClient.saveTask(task);
    //     this.toggleCreateTask()
    //     this.getServiceTasks()
    // }

    // async getCategoriesForTask() {
    //     const cats = await LineworxClient.getServiceTasksCategories();
    
    //     if(cats.body) {
    //         let taskCategories = cats.body.map((cat) => {
    //             return {
    //                 label: cat.task_type_name,
    //                 value: cat.id
    //             }
    //         });
    //         // console.log(taskCategories)
    //         this.setState({
    //             taskCategories
    //         }) 
    //     }
    // }

handleTaskCategoryChange(e) {
    this.setState({
      category_id: e.value
    })
  } 

  removeWorkPacket() {

    var job_copy = this.state.jobForEditView

    job_copy.work_packet_url = null;
    job_copy.work_packet_name = null;
    job_copy.work_packet_size = 0;
    job_copy.work_packet_type = null;

    this.setState({
        jobForEditView: job_copy,
        isJobDirty: true
    })
  }

  removeFile(type, index) {
    
    var packet = this.state.activeTicketCopy
    
    if(type === 'nra') {
        packet.nra_name = null;
        packet.nra_url = null;
        packet.nra_required = 0;
    }

    if(type === 'dig_safe') {
        packet.dig_safe_url = null;
        packet.dig_safe_name = null;
        packet.dig_safe_required = 0;
    }    

    if(type === 'permit') {
        packet.permits[index].permit_url = null;
        packet.permits[index].permit_name = null;
        packet.permits[index].permit_type = null;
    }
    
    this.setState({
        activeTicketCopy: packet
    }, () => {
        this.checkTicketDirty();
    });
    
  }

  async getWorkingForemen() {
    this.setState({
        updating: true
      })
      const fores = await LineworxClient.getWorkingForemen();
      // console.log(fores.body);
      if(fores.body) {
        let workingForemenForDropdown = fores.body.map((foreman) => {
          return {
            label:foreman.first_name + ' ' + foreman.last_name,
            value:foreman.id
          }
        });

        workingForemenForDropdown = [{label:'Select...', value:null}, ...workingForemenForDropdown]

        this.setState({
          workingForemen: fores.body,
          workingForemenForDropdown,
          updating: false
        });
      } else {
        this.setState({
          updating: false
        });
      }    
  }

    async getForemen() {
        this.setState({
          updating: true
        })
        const fores = await LineworxClient.getForemen();
        // console.log(fores.body);
        if(fores.body) {
          let foremenForDropdown = fores.body.map((foreman) => {
            return {
              label:foreman.first_name + ' ' + foreman.last_name,
              value:foreman.id
            }
          });

          this.setState({
            foremen: fores.body,
            foremenForDropdown,
            updating: false
          });
        } else {
          this.setState({
            updating: false
          });
        }        
      }

    //   async getServiceTasks() {
    //     const tasks = await LineworxClient.getServiceTasks();
    //     let taskTypes = [];
    //     if(tasks.body) {
    //         tasks.body.map((task) => {
    //             if(taskTypes.indexOf(task.task_type_name) < 0) {
    //                 taskTypes.push(task.task_type_name);
    //             }
    //         })
            
    //         if(taskTypes.length>0) {
    //             this.setState({
    //                 [taskTypes[0]]:true
    //             });
    //         }
    //         this.setState({
    //             serviceTasks:tasks.body,
    //             taskTypes: taskTypes
    //         });
            
    //     }
    // }


    getJob = async (jid) => {
        if (jid) {
          let jobResponse = await LineworxClient.getJobById(jid);
          // console.log(jobResponse.body);
          if (jobResponse.response.ok) {
            this.populateStateFromJob(jobResponse.body);
          }
        }
      }

      populateStateFromJob(job) {
      
        //let ticket_display = true; //job.work_packet != undefined ? job.work_packet.length>0 : false;
        let poles = new Set();
        
        let allPole = {label:"All", value:-1};
        poles.add(allPole);
        job.tickets.map(ticket => {
            return poles.add(ticket.pole_name);
        });
        job.due_date = moment(job.due_date).utc().format('MMM DD, YYYY');
        // console.log(job.due_date);
        let lines = new Set();
        let allLine = {label:"All", value:-1};
        lines.add( allLine);
        job.tickets.map(ticket => {
          return lines.add(ticket.line_name);
        });

        // console.log(job);
        this.getAllPolesByUtility(job.selected_utility_id)
        //let editJob = JSON.parse(JSON.stringify(job));
        this.setState({
          job,
          //jobForEditView:editJob,
          filteredPole: allPole.label,
          filteredLine:allLine.label,
          filteredStatus:'All',
          uniquePoles:Array.from(poles),
          uniqueLines:Array.from(lines),
        }, () => {
            let filteredTickets = this.filterTheseTickets(job.tickets);
            let tickets = job.tickets;
            this.setState({
                filteredTickets,
                tickets
            })
        });
      }

      async deleteJob () {
        if(window.confirm("Are you sure you want to delete this job?")) { 
            let jobResponse = await LineworxClient.deleteJobById(this.state.job.id);
            if(jobResponse.response.ok) {
              window.location.href = '/jobs';
            }
        }
      }

      /** Edit job */
      closeEditJob(isSaveAction = false) {
        if (!isSaveAction && this.state.isJobDirty === true) {
            if (window.confirm("You have unsaved changes. If you close you will lose these changes. Close anyway?")) {
                this.resetChildrenState();
                this.setState({
                    jobForEditView: undefined
                });
            }
        } else {
            this.resetChildrenState();
            this.setState({
                jobForEditView: undefined
            });
        }
    }
      // showCreateTask(event) {
      //   this.setState({
      //       showCreateTask: true
      //   })
      // }

      showEditJob(event) {
          // console.log("Show edit job");
        let jobForEditView = JSON.parse(JSON.stringify(this.state.job));  
        jobForEditView.due_date = moment(jobForEditView.due_date).utc();
        this.setState({
            jobForEditView
        }, () => {
            this.canSaveJob();
        });
      }

      hideCalendarFromDocClickIfNeeded(e) {
        // console.log(e.target.className);
        if(!e.target.className)return;
        if ((typeof e.target.className) !=="string") {
          // console.log("Saved it ");  
          return
        }
        if(e.target.className.indexOf("calendar") > -1)return;
        if(e.target.id !== "calendar") {
            this.hideEndDateCalendar();
        }
    }

    hideEndDateCalendar() { 
        // console.log("Hiding end date calendar");
      this.setState({
          showDueDateCalendar: false
        })  
    }

      checkJobDirty() {
        let origJob = JSON.parse(JSON.stringify(this.state.job));
        origJob.due_date = moment.utc(origJob.due_date).format('MM/DD/YY');
        origJob.tickets = [];
        origJob.packet = null;
        let original = JSON.stringify(origJob);
        
        let editJob = JSON.parse(JSON.stringify(this.state.jobForEditView));
        editJob.tickets = [];
        editJob.packet=null;
        editJob.work_packet_size = String(editJob.work_packet_size);
        editJob.due_date = moment.utc(editJob.due_date).format('MM/DD/YY');
        let edited = JSON.stringify(editJob);
          let isJobDirty=true;
          
          if(original === edited) {
            isJobDirty = false;
          }

          // console.log(original);
          // console.log(edited);
          // console.log(isJobDirty);

          this.setState({
            isJobDirty
          });
      }

    isNotEmpty(inVar) {
        let ret = false;
        if(inVar) {
            ret = true;
        }
        return ret;   
    }
    canSaveJob() {
        this.checkJobDirty();
        let job = this.state.jobForEditView;
        let jobCanSave =  (this.isNotEmpty(job.due_date)
            && (job.selected_utility_id && job.selected_utility_id !== -1) 
            && job.work_packet_url != null);
        
            // console.log(JSON.stringify(job));
            // console.log(jobCanSave);
        this.setState({
            jobCanSave
        });
      }

      async saveJob() {
        let job = this.state.jobForEditView; //createJobObjectForEdit()
        job.tickets = {}; //we don't need to send the tickets back to server, causing a 413 error when lots of tickets included
        // console.log(job);
        let resp = await LineworxClient.saveJob(job);
        // console.log(resp);
        this.populateStateFromJob(resp.body.job);
        
        this.setState({
          isJobDirty: false
        });
    
        this.closeEditJob(true); 
    }

    // createJobObjectForEdit() {
    //     let job = {};
        
    //     job.selectedUtility = this.state.jobForEditView.uc_id;
    //     job.selectedForeman = this.state.jobForEditView.foreman_id;
    //     job.dueDate = this.state.jobForEditView.due_date;
    //     job.jobNumber = this.state.jobForEditView.job_number;
    //     job.jobType = this.state.jobForEditView.job_type;
        
    
    //     let packet = {}
    //     packet.name = this.state.jobForEditView.work_packet_name;
    //     packet.s3Url = this.state.jobForEditView.work_packet;
    //     packet.size = this.state.jobForEditView.work_packet_size;
    //     packet.type = this.state.jobForEditView.work_packet_type;

    //     job.packet = packet;
    
    //     job.hospitalName = this.state.jobForEditView.hospital_name;
    //     job.hospitalAddress = this.state.jobForEditView.hospital_address;
    //     job.id = this.state.jobForEditView.id;
        
    //     return job;
    //   }


    handleWorkContactPhone(text) {
        let jobForEditView = this.state.jobForEditView;
        jobForEditView.work_contact_phone = text;
        this.setState({
            jobForEditView

        }, () => {
            this.canSaveJob()
        });
      }

    handleHospName(text) {
        let jobForEditView = this.state.jobForEditView;
        jobForEditView.hospital_name = text;
        this.setState({
            jobForEditView
          }, () => {
            this.canSaveJob();
        })
    }

    handleHospAddress(text) {
        let jobForEditView = this.state.jobForEditView;
        jobForEditView.hospital_address = text;
        this.setState({
            jobForEditView
          }, () => {
            this.canSaveJob();
        })
    }

    handleSelectForeman = (option)=> {
        const selectedForeman = option;
        // console.log(selectedForeman);
        let jobForEditView = this.state.jobForEditView;
        jobForEditView.foreman_id = option.value;
        jobForEditView.foreman_name = option.label;
        this.setState({
            jobForEditView
          }, () => {
            this.canSaveJob();
        })
      }

      handleWorkingForemanChange = (option) => {
        // console.log("here");  
        let ticket = this.state.activeTicketCopy;
        if(option.value == null) {
            ticket.assigned_to = null;
            //ticket.assigned_to_name = null;  
        } else {
          ticket.assigned_to = option.value;
          //ticket.assigned_to_name = option.label;
        }
          this.setState({
            activeTicketCopy:ticket
          }, () => {
            this.checkTicketDirty();
        })
      }

    handleSelectJobType(textType) {
        let jobForEditView = this.state.jobForEditView;
        jobForEditView.job_type = textType === "estimation" ? 1 : 0;
        this.setState({
            jobForEditView
          }, () => {
            this.canSaveJob();
        })
    }

    onDueDateChanged(newdate) {
        // console.log(newdate);
        let jobForEditView = this.state.jobForEditView;
        jobForEditView.due_date = moment.utc(newdate).startOf('day');
        this.setState({
            jobForEditView,
            showDueDateCalendar:false
          }, () => {
            this.canSaveJob();
        })
    }



    handleSelectUtility(utility) {
        let jobForEditView = this.state.jobForEditView;
        //jobForEditView.selectedUtility = utility;
        jobForEditView.selected_utility_id = utility.value;
        jobForEditView.selected_utility_name = utility.label;

        this.setState({
            jobForEditView
          }, () => {
            this.canSaveJob();
        })
    }


    triggerFileSelectDialog() {
        this.xlsUpload.current.click();
    }

    async handlePacketDrop (files) {
        
        let jobForEditView = this.state.jobForEditView;
        this.setState({
            loadingPacket:true
          });
        if(files && files.length > 0) {
          let url = await LineworxClient.getUploadUrl("work_packet");
          // console.log(files);
          //let parsed = JSON.parse(url.body);
          let resp = await LineworxClient.uploadFileToS3(url.body.signedRequest, files[0]);
    
          if(resp.ok) {
            files[0].uploadUrl = url.body.signedRequest;
            files[0].s3Url = url.body.url;

            let strPacket = JSON.stringify(files[0]);
            let packetObj = JSON.parse(strPacket);
            packetObj.name = files[0].name;
            packetObj.size = files[0].size;
            packetObj.type = files[0].type;
            jobForEditView.packet = packetObj;
            jobForEditView.work_packet_url = url.body.url;
            jobForEditView.work_packet_name = files[0].name;
            jobForEditView.work_packet_size = files[0].size;
            jobForEditView.work_packet_type = files[0].type;
            this.setState({
                jobForEditView
            }, () => {
                this.canSaveJob();
            });
          }
        } else {
            jobForEditView.packet = undefined;
            this.setState({
                jobForEditView
            }, () => {
                this.canSaveJob();
            });
        }        
        this.setState({
            loadingPacket:false
          });
        //this.saveJob();
    }


    toggleShowDueDateCalendar() {
        this.setState({
            showDueDateCalendar : !this.state.showDueDateCalendar
          });
    }

    
      /**End edit job */

      async handlePoleFilterSelect(e) {
        if(e.recurse === undefined || e.recurse === true) {
            // console.log("Resetting line");
            await this.handleLineFilterSelect({label:'All', recurse:false});
        }
        this.setState({
            filteredPole:e.label
        }, () => {
          let filteredTickets = this.filterTheseTickets(this.state.tickets);
          this.setState({
            filteredTickets,
          });
        });
    }
  
    async handleLineFilterSelect(e) {
      if(e.recurse === undefined || e.recurse === true) {
          // console.log("Resetting pole");
          await this.handlePoleFilterSelect({label:'All', recurse:false});
      }
      // console.log("Line filter");  
        this.setState({
            filteredLine:e.label
        }, () => {
          let filteredTickets = this.filterTheseTickets(this.state.tickets);
          this.setState({
            filteredTickets,
          });
        });
    }
  
    async handleStatusFilterSelect(e) {

      // console.log("Status filter");  
        this.setState({
            filteredStatus:e.label
        }, () => {
          let filteredTickets = this.filterTheseTickets(this.state.tickets);
          this.setState({
            filteredTickets,
          });
        });
    }
  
  filterTheseTickets(tickets) {
      if(!tickets)return;

      
      let filtered = tickets.filter((ticket) => {
          let shouldBeIn = (this.state.filteredPole == null || 
              ticket.pole_name === this.state.filteredPole || 
              this.state.filteredPole === "All");
          
          
          shouldBeIn = shouldBeIn &&
              (
                  this.state.filteredLine == null || 
              ticket.line_name === this.state.filteredLine || 
              this.state.filteredLine === "All"
              );
          
          shouldBeIn = shouldBeIn &&
              (
                  this.state.filteredStatus == null || 
              ticket.status === this.state.filteredStatus || 
              this.state.filteredStatus === "All"
              );
      
          return shouldBeIn;
          
        });
        return filtered;
    }
  
    async getAccessibilityTypes() {
        const types = await LineworxClient.getAccessTypes();
        if(types.body) {
            let accessTypesForDropdown = types.body.map((access_type) => {
                return {
                    label:access_type.title,
                    value:access_type.id
                }
            });
            this.setState({
                accessTypesForDropdown
            });
        }
    }

  async getUtilities() {
    this.setState({
      updating: true
    })
    const utils = await LineworxClient.getUtilities();
    if(utils.body) {
      let utilsForDropdown = utils.body.map((utility) => {
        return {
          label:utility.code,
          value:utility.id
        }
      });
      this.setState({
        utilities: utils.body,
        utilsForDropdown,
        updating: false
      });
    } else {
      this.setState({
        updating: false
      });
    }        
  }

  async getAllPolesByUtility(utility) {
    this.setState({
      updating: true
    })
    const polesReturn = await LineworxClient.getPolesByUtility(utility);
    // console.log("Poles returned");
    if(polesReturn.body) {
        // console.log(polesReturn.body.poles);
        this.setState({
          availablePoles: polesReturn.body.poles,
          updating: false
        });
    } else {
      this.setState({
        updating: false
      });
    }        
  }

    handleBack() {
        this.props.history.replace('/jobs');
    }

    viewTicket(ticket) {
        let activeTicketCopy = JSON.parse(JSON.stringify(ticket))
        let poleCopy = ticket.pole ? JSON.parse(JSON.stringify(ticket.pole)) : {};
        this.setState({ 
            activeTicket:ticket,
            activeTicketCopy,
            activeTicketDirty:false,
            activePoleDirty:false,
            activePoleCopy:poleCopy,
            showStationSelections:false,
        });
    }

    createEmptyTicket() {
        return {pole:{}, notes:[], tasks:[], work_orders:[], permits:[], job_id:this.state.job.id};
    }
    async addPole(searchPoleText, searchLineText, utilityForPoleView, dueDate) {
        console.log(searchPoleText)
        console.log(searchLineText)
        console.log(utilityForPoleView)
        if(!searchPoleText || !searchLineText || !utilityForPoleView) {
            alert('Fill out the pole name, line name, and utility before adding a pole');
            return
        }
        
        const existingTicket = this.state.job.tickets.find(ticket => 
            ticket.pole_name === searchPoleText && 
            ticket.line_name === searchLineText
        );
        
        if (existingTicket) {
            alert('A ticket for this pole already exists in this job. Please select the existing pole instead of creating a new one.');
            return;
        }
        
        this.setState({addPoleError:false});
        this.setState({loading:true});
        try {
            const poleId = this.state.activePoleCopy?.pole_id || '';
            const lineId = this.state.activePoleCopy?.line_id || '';
            
            let ret = await LineworxClient.addPoleByPoleLineUtil(searchPoleText, searchLineText, utilityForPoleView.label, poleId, lineId, dueDate ? dueDate : null);
            console.log(ret);
            this.setState({loading:false});
            if(ret.response.ok === true) {
                let pPole = await LineworxClient.getExactPoleWUtility(searchPoleText, searchLineText, utilityForPoleView.label);
                if(pPole.response.ok) {
                    console.log("Got pole after add");
                    console.log(pPole);
                    if(pPole.body && pPole.body.length > 0) {
                        const newPole = pPole.body[0];
                        newPole.due_date = dueDate;
                        newPole.pole_id = poleId;
                        newPole.line_id = lineId;
                        
                        const newTicket = {
                            pole: newPole,
                            pole_id: newPole.id,
                            job_id: this.state.job.id,
                            notes: [],
                            tasks: [],
                            work_orders: [],
                            permits: [],
                            due_date: dueDate || null
                        };
                        let ticketResp = await LineworxClient.saveTicket(newTicket);
                        if (ticketResp.response.ok && ticketResp.body.ticket) {
                            let updatedJob = { ...this.state.job };
                            let newTicketWithFlag = { ...ticketResp.body.ticket, justCreated: true };
                            updatedJob.tickets = [...updatedJob.tickets, newTicketWithFlag];
                            let updatedFilteredTickets = this.filterTheseTickets(updatedJob.tickets);
                            this.setState({
                                job: updatedJob,
                                filteredTickets: updatedFilteredTickets,
                                activeTicket: newTicketWithFlag,
                                activeTicketCopy: JSON.parse(JSON.stringify(newTicketWithFlag)),
                                activePoleCopy: newTicketWithFlag.pole
                            }, () => {
                                this.changePoleOnTicket(newTicketWithFlag.pole);
                            });
                        }
                    }
                }
                
            } else {
                this.setState({addPoleError:true});
            }
        } catch(err) {
            this.setState({addPoleError:true});
            this.setState({loading:false});
        }
    }

    async toggleCreateTicket(event) {
        let tickId = 0;
    
        if(event) tickId = Number(event.target.dataset.ticket_id);
        
        // Always use the most up-to-date ticket data from the job state
        let activeTicket = this.state.job.tickets.find(ticket => {
            return ticket.id === tickId;
        });
        
        if(activeTicket) {
            // Create a deep copy of the ticket to avoid reference issues
            const ticketCopy = JSON.parse(JSON.stringify(activeTicket));
            this.viewTicket(ticketCopy);
        } else if(!this.state.activeTicket) {
            const emptyTicket = this.createEmptyTicket();
            this.setState({ 
                activeTicket: emptyTicket,
                activeTicketCopy: JSON.parse(JSON.stringify(emptyTicket)),
                activeTicketDirty: false,
                activePoleDirty: false,
                activePoleCopy: {},
                showStationSelections: false,
                needsMerge: false,
                selectedTab: 'home'
            });
        } else {
            this.setState({ 
                activeTicket: undefined,
                activeTicketCopy: undefined,
                activeTicketDirty: false
            });
        }
    }
    
    
    resetPoleId(text) {
        let p = JSON.parse(JSON.stringify(this.state.activePoleCopy));
        // console.log(p);
        if (p.id) {
            p.id=null;
            this.setState({
                activePoleCopy:p,
                showStationSelections:false,
                needsMerge:false
              })    
        } 
    }

    changePoleText(text) {
        let p = JSON.parse(JSON.stringify(this.state.activePoleCopy));
        // console.log(p);
        if (p.id) {
            // console.log("pole id");
            p.id=null;
            p.pole_name = text;
        } else {
            p = JSON.parse(JSON.stringify(this.state.activePoleCopy));
            p.pole_name = text;
        }

        this.setState({
            activePoleCopy:p,
            showStationSelections:false,
            needsMerge:false
          })
          
    }

    changeLineText(text) {
        let p = JSON.parse(JSON.stringify(this.state.activePoleCopy));
        // console.log(p);
        if (p.id) {
            // console.log("pole id");
            p.id=null;
            p.line_name = text;
        } else {
            p.line_name = text;
        }

        this.setState({
            activePoleCopy:p,
            showStationSelections:false,
            needsMerge:false
          })
    }

    changeSubStationText(text) {
        
        let p = JSON.parse(JSON.stringify(this.state.activePoleCopy));
        // console.log(p);
        if (p.id) {
            // console.log("pole id");
            p.id = null;
            p.sub_curcuit = text;
        } else {    
            p.sub_curcuit = text;
        }

        this.setState({
            activePoleCopy:p,
            showStationSelections:false,
            needsMerge:false
          })
    }

    changeCurcuitText(text) {
        let p = JSON.parse(JSON.stringify(this.state.activePoleCopy));
        // console.log(p);
        if (p.id) {
            // console.log("pole id");
            p.id = null
            p.sap_curcuit = text;
        } else {            
            p.sap_curcuit = text;
        }

        this.setState({
            activePoleCopy:p,
            showStationSelections:false,
            needsMerge:false
          })
    }

    hideDueDateCalendar() {
        if(this.state.showDueDateCalendar) {
          this.setState({
            showDueDateCalendar : false
          });        
        }
      }


    closeWindow(override) {
        // console.log("closing");
        if(this.state.activeTicketDirty && (!override || override === false)) {
            // console.log("dirty")
            if(window.confirm("You have unsaved changes. If you close you will lose these changes. Close anyway?")) {
                this.resetChildrenState();        
                this.setState({
                    activeTicketCopy:undefined
                });
            }
        } else {
            this.resetChildrenState();
            this.setState({
                activeTicketCopy:undefined
            });
        }
        
    }

    changePermitType(text, index) {
        // console.log(text);
        let t = this.state.activeTicketCopy;
        let p = t.permits[index];
        p.permit_type=text

        this.setState({
            activeTicketCopy:t
        }, () => {
            this.checkTicketDirty();
        })
    }

    spreadsheetUpload = async (e) => {
        // console.log(e.target.files);
        if(e.target.files && e.target.files.length > 0) {
            // let url = await LineworxClient.uploadXLSX(e.target.files);
            // //let parsed = JSON.parse(url.body);
            let resp = LineworxClient.uploadXLSX(e.target.files);
            // console.log(resp)      
            if(resp.ok) {
                // console.log(resp)
            }
        }
    }

    changeRadio(which, yesBox, e) {


        let checked = e.target.checked && yesBox;
        let t = this.state.activeTicketCopy;
        
        if(which === 'nra') {
            t.nra_required = checked ? 1 : 0
            this.setState({
                activeTicketCopy:t
            }, () => {
                this.checkTicketDirty();
            })
        } else if (which === 'dig') {
            t.dig_safe_required = checked ? 1 : 0
           this.setState({
                activeTicketCopy:t
            }, () => {
                this.checkTicketDirty();
            })
        }
    }

    async savePole() {
        this.setState({saving:true});
        let ret = await LineworxClient.savePole(this.state.activePoleCopy);
        this.setState({saving:false});
        // console.log(ret.body.pole);
        let t = this.state.activeTicketCopy;
        let t1 = this.state.activeTicket;
        t.pole = ret.body.pole;
        t1.pole = ret.body.pole;

        this.setState({
            activeTicketCopy : t,
            activeTicket: t1
        }, () => {
            this.getJob(this.state.job.id);
            this.checkPoleDirty();
        })
    }

    async wouldPoleNeedMerge() {
        let ticket = this.state.activeTicketCopy
        if(!ticket.pole || !ticket.pole.id) { return -1}
        
        let ticket_ids_return = await LineworxClient.doesPoleNeedMerge(this.state.activeTicketCopy);
        let tickId = this.state.activeTicketCopy.id;
        if(ticket_ids_return && ticket_ids_return.body && ticket_ids_return.body.ticket_ids) {
            let existingTicks = ticket_ids_return.body.ticket_ids;
            if(existingTicks.length > 1) {
                return existingTicks[0].id === tickId ? existingTicks[1].id : existingTicks[0].id
            } else if (existingTicks.length > 0) {
                if(existingTicks[0].id !== tickId) {
                    return existingTicks[0].id
                } else {
                    return -1;
                }
            } else {
                return -1;
            }
        } else {
            return -1;
        }
    }

    async mergeTickets() {
        if(this.state.ticketIdToMerge > 0) {
            this.setState({saving:true});
            //This ticket will be secondary position
            let thisTicket = this.state.activeTicketCopy
            // console.log(`Secondary ticket: ${JSON.stringify(thisTicket)}`);
            // console.log(`Primary ticket: ${this.state.ticketIdToMerge}`);
            let returnValue = await LineworxClient.mergeTickets(this.state.ticketIdToMerge, thisTicket);
            // console.log(JSON.stringify(returnValue));
            this.getJob(this.state.job.id);
            this.setState({saving:false});
            this.closeWindow(true);

        }
    }

    async changePoleOnTicket(pole) {
        // console.log(`Saving pole ${JSON.stringify(pole)}`);
        let ticket = this.state.activeTicketCopy;
        ticket.pole = JSON.parse(JSON.stringify(pole));  
        ticket.pole_id = pole.id;         

        this.setState({
            activeTicketCopy:ticket,
            activePoleCopy:pole
          }, async () => {
            //console.log("saving ticket");
            // console.log(JSON.stringify(this.state.activeTicketCopy));
            let ticketNeedingMerge = await this.wouldPoleNeedMerge();
            // console.log(`Needs merge ereturned ${ticketNeedingMerge}`);
            let needsMerge = ticketNeedingMerge > -1 && ticketNeedingMerge !== this.state.activeTicketCopy.id;
            this.setState({
                needsMerge:needsMerge,
                ticketIdToMerge:needsMerge?ticketNeedingMerge:null
            }, () => {
                this.checkPoleDirty();
            });
            // if(ticketNeedingMerge<0) {
            //     this.checkTicketDirty();
            //     this.saveTicket(this.state.activeTicketCopy);
            // }
            
          });
          
          let p = JSON.parse(JSON.stringify(pole));
          this.setState({
            activePoleCopy:p
          }, () => {
            this.checkPoleDirty();
          });
    }
    
    arcRatingChange(text) {
        this.state.activePoleCopy.arc_rating = text;
        this.setState({
             activePoleCopy : this.state.activePoleCopy
         }, () => {
            this.checkPoleDirty();
        });
    }

    changePoleAddress(text) {
        let activePoleCopy = this.state.activePoleCopy
        activePoleCopy.street_address = text;
        this.setState({
             activePoleCopy
         }, () => {
            this.checkPoleDirty();
        });
    }

    secondaryVoltageChange(text) {
        this.state.activePoleCopy.secondary_voltage = text;
        this.setState({
             activePoleCopy : this.state.activePoleCopy
         }, () => {
            this.checkPoleDirty();
        });
    }

    primaryVoltageChange(text) {
        this.state.activePoleCopy.primary_voltage = text;
        this.setState({
             activePoleCopy : this.state.activePoleCopy
         }, () => {
            this.checkPoleDirty();
        });
    }

    latitudeChange(text) {
        // parseFloat and Number trim off the trailing 0
        // so have to treat it like a string, since it isn't
        // being used to calculate anything, can't use toFixed either
        let dec = text.split('.');
        
        if(dec && dec[1]) {
            if(dec[1].length > 6) {
                dec[1] = dec[1].substr(0, 6);
            }
            text = dec[0] + '.' + dec[1];
        }

        this.state.activePoleCopy.geo_lat = text;
        this.setState({
             activePoleCopy : this.state.activePoleCopy
         }, () => {
            this.checkPoleDirty();
        });
    }

    longitudeChange(text) {
        // parseFloat and Number trim off the trailing 0
        // so have to treat it like a string, since it isn't
        // being used to calculate anything, can't use toFixed either
        let dec = text.split('.');
        if(dec && dec[1]) {
            if(dec[1].length > 6) {
                dec[1] = dec[1].substr(0, 6);
            }
            text = dec[0] + '.' + dec[1];
        }
        // console.log(text)
        this.state.activePoleCopy.geo_lon = text;
        this.setState({
             activePoleCopy : this.state.activePoleCopy
         }, () => {
            this.checkPoleDirty();
        });
    }

    handleSelectAccessType(text) {
        // console.log(text);
        this.state.activePoleCopy.accessibility_id = text.value;
        this.state.activePoleCopy.accessibility_label = text.label;
        this.setState({
             activePoleCopy : this.state.activePoleCopy
         }, () => {
            this.checkPoleDirty();
        });
    }

    checkTicketDirty() {
      // console.log('checking')
      // if(!this.state.activeTicket || !this.state.activeTicketCopy) {return}
      const isNewTicket = !this.state.activeTicket;
      const utilityId = this.state.activeTicketCopy?.pole?.utility_id_owning_pole;
      console.log('isNewTicket:', isNewTicket, 'utilityId:', utilityId);
      if (isNewTicket && utilityId && utilityId !== -1 && utilityId !== "" && utilityId !== null && utilityId !== undefined) {
        this.setState({ activeTicketDirty: true });
        return;
      }

      if (!this.state.activeTicket || !this.state.activeTicketCopy) {
        this.setState({
          activeTicketDirty: false
        });
        return;
      }

      let t1 = JSON.parse(JSON.stringify(this.state.activeTicket));
      let t2 = this.state.activeTicketCopy;

      if(!t1.assigned_to) {
          t1.assigned_to = null;
      }

      let t1String =  JSON.stringify(t1);
      let t2String = JSON.stringify(t2);
      let ticketDirty = t1String !== t2String;
      
      let poleDirty = false;
      if (this.state.activeTicket.pole && this.state.activePoleCopy) {
        let p1 = JSON.parse(JSON.stringify(this.state.activeTicket.pole));
        let p2 = this.state.activePoleCopy;
        let p1String = JSON.stringify(p1);
        let p2String = JSON.stringify(p2);
        poleDirty = p1String !== p2String;
      }
      
      let dirty = ticketDirty || poleDirty;
      this.setState({
          activeTicketDirty:dirty
      });
    }

    checkPoleDirty() {
        let t1 = this.state.activeTicketCopy.pole;
        let t2 = this.state.activePoleCopy;
        let t1String =  JSON.stringify(t1);
        let t2String = JSON.stringify(t2);
        //console.log(t1String);
        //console.log(t2String);
        let dirty = t1String !== t2String;
        // console.log(dirty);
        this.setState({
            activePoleDirty:dirty
        });
    }

    updateTicketDescription(new_description){
      console.log(new_description)
      let activeTicket = this.state.activeTicketCopy;
      activeTicket.description = new_description
      
      this.setState({
        activeTicketCopy: activeTicket
      }, () => {
          this.checkTicketDirty();
      });
    }


    handleDigDrop = async (files) => {
        //console.log('handle dig drop' + JSON.stringify(files));
      let activeTicket = JSON.parse(JSON.stringify(this.state.activeTicketCopy));

      this.setState({
        loadingDigSafeDnD:true
      });

      if(files && files.length > 0) {
        let url = await LineworxClient.getUploadUrl("dig_file");
        //let parsed = JSON.parse(url.body);
        let resp = await LineworxClient.uploadFileToS3(url.body.signedRequest, files[0]);
  
        if(resp.ok) {
            activeTicket.dig_safe_url = url.body.url;
            activeTicket.dig_safe_name = files[0].name;
            activeTicket.dig_safe_required = 1;
            this.setState({
                activeTicketCopy: activeTicket
              }, () => {
                  this.checkTicketDirty();
              });
            } 
        }
        
        this.setState({
          loadingDigSafeDnD:false
        });
    }

    handleNRADrop = async (files) => {

      let activeTicket = JSON.parse(JSON.stringify(this.state.activeTicketCopy));
      
      this.setState({
        loadingNRADnD:true
      });

      if(files && files.length > 0) {
        let url = await LineworxClient.getUploadUrl("nra_file");
        //let parsed = JSON.parse(url.body);
        let resp = await LineworxClient.uploadFileToS3(url.body.signedRequest, files[0]);
  
        if(resp.ok) {
            activeTicket.nra_url = url.body.url;
            activeTicket.nra_name = files[0].name;
            activeTicket.nra_required = 1;
            this.setState({
                activeTicketCopy: activeTicket
              }, () => {
                  this.checkTicketDirty();
              });
        }
      }
      this.setState({
        loadingNRADnD:false
      });
  }

  handlePermitDrop = async (files, index) => {

    let activeTicket = JSON.parse(JSON.stringify(this.state.activeTicketCopy));
    let loadingPermitDnD = [];
    loadingPermitDnD[index] = true;
    this.setState({
        loadingPermitDnD
    })
    let permit = activeTicket.permits[index];

    if(files && files.length > 0) {
      let url = await LineworxClient.getUploadUrl("permit");
      //let parsed = JSON.parse(url.body);
      let resp = await LineworxClient.uploadFileToS3(url.body.signedRequest, files[0]);
      
      //How to find the right permit object??
      
      if(resp.ok) {
          permit.permit_url = url.body.url;
          permit.permit_name = files[0].name;
          this.setState({
              activeTicketCopy: activeTicket
            }, () => {
                this.checkTicketDirty();
            });
      }
    }
    
    loadingPermitDnD[index] = false;
    this.setState({
        loadingPermitDnD
    })
}


  

    setSpecText(text){
        let poleCopy = JSON.parse(JSON.stringify(this.state.activePoleCopy));
        poleCopy.utility_spec = text;
        this.setState({
            activePoleCopy: poleCopy
        }, () => {
            this.checkPoleDirty();
        });
    }

    // expandTaskSection(name) {
    //     let expandedTaskSections = this.state.expandedTaskSections;
    //     // console.log(expandedTaskSections);
    //     // console.log(name);
    //     let idx = expandedTaskSections.indexOf(name);
    //     if(idx > -1) {
    //         expandedTaskSections.splice(idx, 1);
    //     } else {
    //         expandedTaskSections.push(name);
    //     }
    //   this.setState ({expandedTaskSections})
    // }


    // taskChecked = async (e) => {
    //   let assignedTasks = this.state.activeTicketCopy.tasks.slice();
    //   let id = e.target.id;
    //   let alreadyIn = await assignedTasks.filter((task) => task.task_id == id ).length > 0;
    //   let serviceTask = await this.state.serviceTasks.find((t)=>t.task_id == id);

    //   if(!alreadyIn && serviceTask) {
    //       assignedTasks.push({task_id:Number(id)});
    //   } else {
    //       assignedTasks = assignedTasks.filter((task) => task.task_id != id ) 
    //   }

    //   let activeTicket = this.state.activeTicketCopy;
    //   activeTicket.tasks = assignedTasks
    //   this.setState({
    //     activeTicketCopy: activeTicket
    //   }, () => {
    //     this.checkTicketDirty();
    //   });
    // }

  tasksChanged(tasks) {
    if (this.state.activeTicketCopy) {
      let updatedTicket = { ...this.state.activeTicketCopy }
      updatedTicket.tasks = tasks
      this.setState({
        activeTicketCopy: updatedTicket
      }, this.checkTicketDirty()
      );
    }

  }

    handleAmbMeetup(e) {
    let t = this.state.activeTicketCopy
    t.ambulance_meetup = e.target.value;
      this.setState({
        activeTicketCopy:t
      }, () => {
        this.checkTicketDirty();
      });
    }

    handleEhasp(e) {
        // console.log("handleEhasp")
        let t = this.state.activeTicketCopy
        t.ehasp = e.target.value;
          this.setState({
            activeTicketCopy:t
          }, () => {
            this.checkTicketDirty();
          });
        }

    addPermit() {
      let t = this.state.activeTicketCopy;
      let permitsCopy = t.permits.slice();
      permitsCopy.push({permit_url:null, permit_name:null, filename:null, permit_type:null});
      t.permits = permitsCopy;
      this.setState( {
          activeTicketCopy:t
      }, () => {
        this.checkTicketDirty();
      });
  }

  toggleAddNote() {
      //console.log(moment("Just Now").isValid());
      let activeWorkingNote = null;
      if(!this.state.activeWorkingNote) {
          activeWorkingNote = {note_text:null, created_date:"Just Now", author:"Me"};
      }
      this.setState({
          activeWorkingNote
      })
  }

  updateActiveNote(e) {
    // console.log(e);
    let text = e.target.value;
      let activeWorkingNote = this.state.activeWorkingNote;
      activeWorkingNote.note_text = text;
      this.setState({
          activeWorkingNote
      })
  }

  addNote() {
    let activeTicket = JSON.parse(JSON.stringify(this.state.activeTicketCopy));
    let awn = this.state.activeWorkingNote;
    let notes = [...activeTicket.notes, awn];
    // console.log(notes);
    //notes.push(awn);
    activeTicket.notes = notes;

    // console.log("Pushing");
    this.setState({
      activeTicketCopy: activeTicket
    }, () => {
        this.checkTicketDirty();
    });
    this.toggleAddNote();
  }

  handleDeleteWoChip = (wo) => {
    let activeTicket = JSON.parse(JSON.stringify(this.state.activeTicketCopy));

    let new_wo = activeTicket.work_orders.filter(e => e !== wo);
   
    activeTicket.work_orders = new_wo
    this.setState({
      activeTicketCopy: activeTicket
    }, () => {
        this.checkTicketDirty();
      });

  }

handleAddWoChip = (wo) => {
  let activeTicket = JSON.parse(JSON.stringify(this.state.activeTicketCopy));

  activeTicket.work_orders = [...activeTicket.work_orders, wo]

  this.setState({
    activeTicketCopy: activeTicket
  }, () => {
    this.checkTicketDirty();
  });
}

    async getSpecificPole(e, station) {
        //console.log(e);
        //Get the pole, and set the original and a copy on state
        let poleText = this.state.activePoleCopy.pole_name
        let lineText = this.state.activePoleCopy.line_name;
        this.setState({addPoleError:false});
        if(poleText && lineText) {
            
            const specific_pole = await LineworxClient.getExactPole(poleText, lineText);
            if (specific_pole.body && specific_pole.body.length > 0) {
                //console.log(specific_pole.body)
                if(station) {
                    let pole = specific_pole.body.find((pole) => {
                        // console.log(`${pole.sub_curcuit} ${station}`);
                        return pole.sub_curcuit === station.label;
                    });
                    this.setState({
                        activePoleCopy:pole
                    });
                    this.changePoleOnTicket(pole);
                    return;
                } 
                if(specific_pole.body.length > 1) {    
                    let subStations = specific_pole.body.map((s_pole) => {
                        return {
                            label:s_pole.sub_curcuit,
                            value:s_pole.id,
                        }
                    });
                    // console.log(subStations);
                    this.setState({
                        showStationSelections: true,
                        subStations
                    })
                    return
                } else {
                    this.setState({
                        showStationSelections: false
                    });
                }
                this.changePoleOnTicket(specific_pole.body[0])
                
            } else {
                //Clear out substation and curcuit
                this.setState({
                    showStationSelections: false
                });
                this.changePoleOnTicket({pole_name:poleText, line_name:lineText});
            }
        }
    }

    async saveTicket() {
        console.log('Starting saveTicket with activeTicketCopy:', this.state.activeTicketCopy);
        const isNew = this.state.activeTicketCopy && this.state.activeTicketCopy.justCreated;
        if(this.state.activeTicketDirty || isNew) {
            this.setState({saving:true});
            
            // If pole data has been modified, save it first
            if (this.state.activePoleDirty && this.state.activePoleCopy && this.state.activePoleCopy.id) {
                console.log('Saving pole data first...');
                try {
                    let poleResp = await LineworxClient.savePole(this.state.activePoleCopy);
                    console.log('Save pole response:', poleResp);
                    
                    if (poleResp.response.ok) {
                        // Update the ticket's pole reference with the saved pole data
                        let ticketCopy = JSON.parse(JSON.stringify(this.state.activeTicketCopy));
                        ticketCopy.pole = poleResp.body.pole;
                        this.setState({
                            activeTicketCopy: ticketCopy,
                            activePoleCopy: poleResp.body.pole,
                            activePoleDirty: false
                        });
                    }
                } catch (error) {
                    console.error('Error saving pole:', error);
                }
            }
            
            let resp = await LineworxClient.saveTicket(this.state.activeTicketCopy);
            console.log('Save ticket response:', resp);
            
            let ticketResp = resp.body.ticket
            if (ticketResp && ticketResp.notifyMergeRequired && ticketResp.notifyMergeRequired === true && ticketResp.ticketIdToMerge) {
                // ... error handling ...
            }
            else {
                console.log('Ticket saved successfully, updating state with saved data');
                let updatedJob = { ...this.state.job };
                const ticketIndex = updatedJob.tickets.findIndex(t => t.id === ticketResp.id);
                let finalTicket = ticketResp;
                if (this.state.activePoleCopy && this.state.activePoleCopy.id) {
                    finalTicket = {
                        ...ticketResp,
                        pole: this.state.activePoleCopy
                    };
                }
                if (ticketIndex !== -1) {
                    updatedJob.tickets[ticketIndex] = finalTicket;
                } else {
                    updatedJob.tickets = [...updatedJob.tickets, finalTicket];
                }
                let updatedFilteredTickets = this.filterTheseTickets(updatedJob.tickets);
                if (isNew) {
                    let ticketCopy = { ...this.state.activeTicketCopy };
                    delete ticketCopy.justCreated;
                    this.setState({ activeTicketCopy: ticketCopy });
                }
                this.setState({
                    job: updatedJob,
                    filteredTickets: updatedFilteredTickets
                });
                this.setState({
                    mergeRequired: false,
                    overrideMerge: false,
                    saving: false,
                    activeTicket: ticketResp,
                    activeTicketCopy: ticketResp ? JSON.parse(JSON.stringify(ticketResp)) : undefined,
                    activeTicketDirty: false
                }, () => {
                    this.checkTicketDirty();
                    this.closeWindow(true);
                });
            }
        } else {
            console.log('Ticket not dirty, skipping save');
        }
    }

    changeDueDate = (dueDate) => {
        let ticketCopy = JSON.parse(JSON.stringify(this.state.activeTicketCopy));
        ticketCopy.due_date = dueDate;
        
        this.setState({
            activeTicketCopy: ticketCopy
        }, () => {
            this.checkTicketDirty();
        });
    }

    handlePackageFileSelectClick() {
        this.job_packet.current.click();
    }

    handleCSVUpload() {
        
    }

    handleDigFileSelectClick() {
        this.digsafe.current.click();
    }

    handleNraFileSelectClick() {
        this.nra.current.click();
    }

    handlePermitFileSelectClick() {
        this.permit_0.current.click();
    }

    handleDigSafeFileUpload(e) {
        this.handleDigDrop(e.target.files)
    }

    handleNRAFileUpload(e) {
        this.handleNRADrop(e.target.files)
    }

    handlePermitFileUpload(index, e) {
        this.handlePermitDrop(e.target.files, index)
    }

    handleJobPacketUpload(e) {
        this.handlePacketDrop(e.target.files)
    }

    handleSelectTicketTab(text) {
        this.setState({
            selectedTab:text
        })
    }

    sortBy(type) {
        let sort_dir = this.state.sort_dir === 'asc' ? 'desc' : 'asc';
        if(type !== this.state.sort_col) {
          sort_dir = 'asc';
        }
        let sorted;
        if(type === 'due_date') {
          sorted = [...this.state.filteredTickets].sort((a, b) => {
            const aDate = new Date(a.due_date || 0);
            const bDate = new Date(b.due_date || 0);
            if (isNaN(aDate) && isNaN(bDate)) return 0;
            if (isNaN(aDate)) return 1;
            if (isNaN(bDate)) return -1;
            return sort_dir === 'asc' ? aDate - bDate : bDate - aDate;
          });
        } else if(sort_dir === 'asc') {
          sorted = this.state.filteredTickets.sort(function(a, b) {
            if(type === 'dig_safe_required' || type === 'nra_required') {
                let a1 = a[type];
                let b1 = b[type];
                let atype = (isNaN(Number(a1)) ? 0 : Number(a1))
                let btype = (isNaN(Number(b1)) ? 0 : Number(b1))
              return (atype ?? 0) > (btype ?? 0) ? 1 : -1  
            }
            return (a[type] ?? "").toLowerCase() > (b[type] ?? "").toLowerCase() ? 1 : -1
          });  
        } else {
          sorted = this.state.filteredTickets.sort(function(a, b) {
            if(type === 'dig_safe_required' || type === 'nra_required') {
                let a1 = a[type];
                let b1= b[type] ;
                let atype = (isNaN(Number(a1)) ? 0 : Number(a1))
                let btype = (isNaN(Number(b1)) ? 0 : Number(b1))
                
              return (atype ?? 0) < (btype ?? 0) ? 1 : -1  
            }
            return (a[type] ?? "").toLowerCase() < (b[type] ?? "").toLowerCase() ? 1 : -1
          });  
        }
        this.setState({
            filteredTickets: sorted,
            sort_col: type,
            sort_dir
        })
    }

    handleImageDeleted = async (updatedImages) => {
        if (this.state.activeTicketCopy) {
            const updatedTicket = {
                ...this.state.activeTicketCopy,
                images: updatedImages
            };
            
            this.setState({
                activeTicketCopy: updatedTicket,
                activeTicketDirty: true
            }, () => {
                this.checkTicketDirty();
            });
        }
    };

    handleTicketSelectUtility = (utility) => {
        let poleCopy = JSON.parse(JSON.stringify(this.state.activePoleCopy));
        poleCopy.utility_id_owning_pole = utility.value;
        poleCopy.utility_name = utility.label;
        
        let ticketCopy = JSON.parse(JSON.stringify(this.state.activeTicketCopy));
        if (ticketCopy.pole) {
            ticketCopy.pole.utility_id_owning_pole = utility.value;
            ticketCopy.pole.utility_name = utility.label;
        }

        let originalUtility = this.state.activeTicket?.pole?.utility_id_owning_pole;
        let isDirty = (typeof originalUtility === 'undefined' || originalUtility === null)
            ? true // Always dirty if creating a new ticket
            : originalUtility !== utility.value;

        this.setState({
            activePoleCopy: poleCopy,
            activeTicketCopy: ticketCopy,
            activeTicketDirty: isDirty
        }, () => {
            this.checkPoleDirty();
            this.checkTicketDirty();
        });
    }

    changePoleId = (poleId) => {
        let poleCopy = JSON.parse(JSON.stringify(this.state.activePoleCopy));
        poleCopy.pole_id = poleId;
        this.setState({
            activePoleCopy: poleCopy
        }, () => {
            this.checkPoleDirty();
        });
    }

    changeLineId = (lineId) => {
        let poleCopy = JSON.parse(JSON.stringify(this.state.activePoleCopy));
        poleCopy.line_id = lineId;
        
        let ticketCopy = JSON.parse(JSON.stringify(this.state.activeTicketCopy));
        ticketCopy.line_id = lineId;
        
        this.setState({
            activePoleCopy: poleCopy,
            activeTicketCopy: ticketCopy
        }, () => {
            this.checkPoleDirty();
            this.checkTicketDirty();
        });
    }

    render() {
        return (
            <div>
            <JobView
                job={this.state.job}
                hideDueDateCalendar={this.hideDueDateCalendar}
                deleteJob={this.deleteJob}
                showEditJob={this.showEditJob}
                uniquePoles={this.state.uniquePoles}
                handlePoleFilterSelect={this.handlePoleFilterSelect}
                filteredPole={this.state.filteredPole}
                uniqueLines={this.state.uniqueLines}
                handleLineFilterSelect={this.handleLineFilterSelect}
                filteredLine={this.state.filteredLine}
                statuses={this.state.statuses}
                handleStatusFilterSelect={this.handleStatusFilterSelect}
                filteredStatus={this.state.filteredStatus}
                filteredTickets={this.state.filteredTickets}
                toggleCreateTicket={this.toggleCreateTicket}
                handleBack={this.handleBack}
                sortBy={this.sortBy}
                sort_dir={this.state.sort_dir}
                sort_col={this.state.sort_col}
                removeFile={this.removeFile}
                removeWorkPacket={this.removeWorkPacket}
                toggleCreateTask={this.toggleCreateTask}
                xlsUpload={this.xlsUpload}
                handleCSVUpload={this.triggerFileSelectDialog}
                handleuploadSpreadsheet={this.spreadsheetUpload}


            >
         
            </JobView>



               <TicketView
               active={this.state.activeTicketCopy !=null}
               ticket={this.state.activeTicketCopy}
               utility={this.state.job.selected_utility_name}
               saving={this.state.saving}
               addPoleError={this.state.addPoleError}
               saveTicket={this.saveTicket}
               ticketDirty={this.state.activeTicketDirty}
               //Header Props
               pole={this.state.activePoleCopy}
               activePoleDirty={this.state.activePoleDirty}
               changePoleText={this.changePoleText}
               atLineText={this.state.atLineText}
               atSubStationText={this.state.atSubStationText}
               changeSubStationText={this.changeSubStationText}
               atCurcuitText={this.state.atCurcuitText}
               changeCurcuitText={this.changeCurcuitText}
               changeLineText={this.changeLineText}
               jobNumber={this.state.job.job_number}
               accessTypesForDropdown={this.state.accessTypesForDropdown}
               mergeRequired={this.state.mergeRequired}
               mergeTickets={this.mergeTickets}
               selectedTab={this.state.selectedTab}
               closeTicketWindow={this.closeWindow}
               showStationSelections={this.state.showStationSelections}
               showSavePoleChanges={this.state.showSavePoleChanges}
               savePole={this.savePole}
               addPole={this.addPole}
               tasksChanged={this.tasksChanged}
               needsMerge={this.state.needsMerge}
               subStations={this.state.subStations}
               changePoleAddress={this.changePoleAddress}
               arcRatingChange={this.arcRatingChange}
               secondaryVoltageChange={this.secondaryVoltageChange}
               primaryVoltageChange={this.primaryVoltageChange}
               latitudeChange={this.latitudeChange}
               longitudeChange={this.longitudeChange}
               handleSelectAccessType={this.handleSelectAccessType}
               handleSelectTicketTab={this.handleSelectTicketTab}
               getSpecificPole={this.getSpecificPole}
               workingForemenForDropdown={this.state.workingForemenForDropdown}
               handleWorkingForemanChange={this.handleWorkingForemanChange}
               ticketIdToMerge={this.state.ticketIdToMerge}
               addNote={this.addNote}
               toggleAddNote={this.toggleAddNote}
               activeWorkingNote={this.state.activeWorkingNote}
               addPermit={this.addPermit}
               updateWorkingNote={this.updateActiveNote}
               changePermitType={this.changePermitType}
               handleNRADrop={this.handleNRADrop}
               handleDigDrop={this.handleDigDrop}
               handlePermitDrop={this.handlePermitDrop}
               changeRadio={this.changeRadio}
               handleAmbMeetup={this.handleAmbMeetup}
               handleEhasp={this.handleEhasp}
               specHintData={this.state.specHintData}
               setSpecText={this.setSpecText}
               specText={this.state.specText}
              //  serviceTasks={this.state.serviceTasks}
               updateTicketDescription={this.updateTicketDescription}
              //  expandTaskSection={this.expandTaskSection}
              //  currentTaskSection={this.state.currentTaskSection}
              //  taskChecked={this.taskChecked}
               handleDeleteWoChip={this.handleDeleteWoChip}
               handleAddWoChip={this.handleAddWoChip}
              //  expandedTaskSections={this.state.expandedTaskSections}
               loadingPermitDnD={this.state.loadingPermitDnD}
               loadingDigSafeDnD={this.state.loadingDigSafeDnD}
               loadingNRADnD={this.state.loadingNRADnD}
               digsafe={this.digsafe}
               nra={this.nra}
               permit_0={this.permit_0}
               handleFileSelectClick={this.handleFileSelectClick}
               handleDigFileSelectClick={this.handleDigFileSelectClick}
               handleNraFileSelectClick={this.handleNraFileSelectClick}
               handlePermitFileSelectClick={this.handlePermitFileSelectClick}
               handleDigSafeFileUpload={this.handleDigSafeFileUpload}
               handleNRAFileUpload={this.handleNRAFileUpload}
               handlePermitFileUpload={this.handlePermitFileUpload}
               removeFile={this.removeFile}
               potentialPoles={this.state.availablePoles}
               changePoleOnTicket={this.changePoleOnTicket}
               sortPoles={this.state.sortPoles}
               setPoleSort={this.setPoleSort}
               sortPoleAsc={this.state.sortPoleAsc} 
               setSortPoleAsc={this.setSortPoleAsc}
               utilsForDropdown={this.state.utilsForDropdown}
                job={this.state.job}
                resetPoleId={this.resetPoleId}
                handleImageDeleted={this.handleImageDeleted}
                changePoleId={this.changePoleId}
                changeLineId={this.changeLineId}
                changeDueDate={this.changeDueDate}
                handleTicketSelectUtility={this.handleTicketSelectUtility}
           />
           {this.state.newTask && 
              <TaskView
                closeTaskWindow={this.toggleCreateTask}
                getCategoriesForTask={this.state.taskCategories}
                handleTaskCategoryChange={this.handleTaskCategoryChange}
                saveTask={this.saveTask}
                handleTaskName={this.handleTaskName}
              />
              
            }
           {
               this.state.jobForEditView && 
                <EditJobView 
                    showEditJob={this.state.showEditJob}
                    closeEditJob={this.closeEditJob}
                    job={this.state.jobForEditView}
                    handleSelectJobType={this.handleSelectJobType}
                    dueDateFormatted={this.state.jobDueDateFormatted}
                    toggleShowDueDateCalendar={this.toggleShowDueDateCalendar}
                    showDueDateCalendar={this.state.showDueDateCalendar}
                    onDueDateChange={this.onDueDateChanged}
                    utilsForDropdown={this.state.utilsForDropdown}
                    handleSelectUtility={this.handleSelectUtility}
                    handlePacketDrop={this.handlePacketDrop}
                    saveJob={this.saveJob}
                    hideCalendarFromDocClickIfNeeded={this.hideCalendarFromDocClickIfNeeded}
                    isJobDirty={this.state.isJobDirty}
                    canSaveJob={this.state.jobCanSave}
                    handleHospName={this.handleHospName}
                    handleHospAddress={this.handleHospAddress}
                    handleSelectForeman={this.handleSelectForeman}
                    handleWorkContactPhone={this.handleWorkContactPhone}
                    foremenForDropdown={this.state.foremenForDropdown}
                    handleJobPacketUpload={this.handleJobPacketUpload}
                    job_packet={this.job_packet}
                    handlePackageFileSelectClick={this.handlePackageFileSelectClick}
                    removeFile={this.removeFile}
                    removeWorkPacket={this.removeWorkPacket}
                />
            }
            </div>
        )
    }
}